import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link, useParams } from "react-router-dom";
import { AlertCircle, CheckCircle, Undo2 } from "lucide-react";
import axios from "axios";

const Services = () => {
  const { id } = useParams();
  const [services, setServices] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ✅ Configure Axios Instance
  const axiosInstance = axios.create({
    baseURL: `/${id}/v3`, // Adjust based on your setup
    headers: {
      "Content-Type": "application/json",
    },
  });

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axiosInstance.post("/services");
        setServices(response.data);
      } catch (err) {
        setError(err.response?.data?.message || "Failed to fetch services");
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, [id]); // ✅ Add `id` dependency

  if (loading)
    return (
      <div className="pt-lg-20 pt-10">
        <div className="loader_container">
          <div className="loader_spin"></div>
        </div>
      </div>
    );

  if (error) return <p className="text-red-500">Error: {error}</p>;

  // Separate active and inactive services
  const activeServices = Object.entries(services).filter(
    ([_, service]) => service.status === "active"
  );
  const inactiveServices = Object.keys(services).filter(
    (key) => services[key].status !== "active"
  );

  return (
    <div>
      <div className="bg-back">
        <Header />
        <div className="bg-back">
          <div className="container-fluid px-4 px-lg-14 pt-lg-14 pt-10 pb-10 pb-lg-10">
            <div className="row gx-6 gy-4 align-items-center">
              <div className="d-flex align-items-center">
                <div className="col">
                  <div className="fs-10 text-gray-600">
                    <Link to={"../" + id + "/dashboard"}>
                      <Undo2
                        className="cursor-pointer text-danger mt-n2"
                        size={40}
                      />
                    </Link>{" "}
                    All Service End-Point Status
                  </div>
                </div>
              </div>

              <div className="col-lg-12">
                <div
                  className="card bg-white shadow-none"
                  style={{ borderRadius: "26px" }}
                >
                  <div className="px-5 mt-5">
                    <div className="fs-3 text-dark">List of services</div>
                  </div>

                  {inactiveServices.length > 0 && (
                    <div className="alert alert-danger mt-4">
                      <h4 className="text-danger font-bold">
                        ⚠️ Not Active Services
                      </h4>
                      <ul>
                        {inactiveServices.map((serviceName) => (
                          <li key={serviceName} className="text-gray-700">
                            {serviceName} - {services[serviceName].message}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {activeServices.length > 0 && (
                    <div className="px-8 mt-4">
                      <h3 className="font-bold text-lg">✅ Active Services</h3>
                      <ul className="list-decimal pl-5">
                        {activeServices.map(([key, service]) => (
                          <li
                            key={key}
                            className="p-4 shadow-md rounded-lg flex items-center space-x-4"
                          >
                            <CheckCircle className="text-green-500" size={24} />
                            <div>
                              <h3 className="font-bold text-lg capitalize">
                                {key}
                              </h3>
                              <p className="text-gray-600">{service.message}</p>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
